import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Box } from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { UserContext } from '../../contexts/User';
import { sendRequest } from '../../api/shootAPI';
import API from '../../api/endpoints';

function SetupAlertModal({ closeModal, member, getMembers }) {
  const { activeWorkspace } = useContext(UserContext);
  const [autoSendHR, setAutoSendHR] = useState(member.autoSendHR);
  const [autoSendIT, setAutoSendIT] = useState(member.autoSendIT);
  const [autoSendInfoSec, setAutoSendInfoSec] = useState(member.autoSendInfoSec);
  const [scheduleAdherence, setScheduleAdherence] = useState(!!member.scheduleAdherence);

  const handleSave = async () => {
    const response = await sendRequest({
      method: 'put',
      url: API.WORKSPACE.setupAlert(activeWorkspace.id, member.id),
      data: {
        autoSendHR, autoSendIT, autoSendInfoSec, scheduleAdherence,
      },
    });
    if (response.success) {
      getMembers();
    }
    closeModal();
  };

  return (
    <Modal open onClose={closeModal} className="flex-row align-c jstfy-c" data-testid="delete-member-modal">
      <Box style={{
        width: 482,
        padding: 32,
        background: '#fff',
        borderRadius: 8,
      }}
      >
        <h5 className="m-b20 text-600" data-testid="modal-title">Setup Alert Acknowledge For Member</h5>
        <div>
          <FormGroup>
            <FormControlLabel
              control={(
                <Checkbox
                  checked={autoSendHR && autoSendIT && autoSendInfoSec && scheduleAdherence}
                  onChange={(e) => {
                    setAutoSendHR(e.target.checked);
                    setAutoSendIT(e.target.checked);
                    setAutoSendInfoSec(e.target.checked);
                    setScheduleAdherence(e.target.checked);
                  }}
                />
                      )}
              label="Select All"
            />
            <FormControlLabel
              control={(
                <Checkbox
                  checked={autoSendHR}
                  onChange={(e) => setAutoSendHR(e.target.checked)}
                />
                      )}
              label="HR Bot Alert"
            />
            <FormControlLabel
              control={(
                <Checkbox
                  checked={autoSendIT}
                  onChange={(e) => setAutoSendIT(e.target.checked)}
                />
                      )}
              label="IT Bot Alert"
            />
            <FormControlLabel
              control={(
                <Checkbox
                  checked={autoSendInfoSec}
                  onChange={(e) => setAutoSendInfoSec(e.target.checked)}
                />
                      )}
              label="InfoSec Bot Alert"
            />
            <FormControlLabel
              control={(
                <Checkbox
                  checked={scheduleAdherence}
                  onChange={(e) => setScheduleAdherence(e.target.checked)}
                />
                      )}
              label="Schedule Adherence (HR Bot)"
            />
          </FormGroup>
        </div>
        <div className="newMemberForm-btns" style={{ marginTop: 40 }}>
          <Button
            onClick={closeModal}
            color="secondary"
            sx={{ marginRight: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
          >
            Ok
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

SetupAlertModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  getMembers: PropTypes.func.isRequired,
  member: PropTypes.shape({
    id: PropTypes.number.isRequired,
    autoSendHR: PropTypes.bool.isRequired,
    autoSendIT: PropTypes.bool.isRequired,
    autoSendInfoSec: PropTypes.bool.isRequired,
    scheduleAdherence: PropTypes.bool,
  }).isRequired,
};

export default SetupAlertModal;
